<template>
<v-dialog
  :value="showModal"
  persistent
  @close="$emit('closeModal')"
  :max-width="widthModal"
  :content-class="'modalWithAction'"
>
  <v-card class="modalWithAction__card d-flex flex-column px-6 py-4">
    <div class="modalWithAction__close d-flex justify-end">
      <v-btn
        small
        @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="modalWithAction__title" v-html="title"/>
    <div class="modalWithAction__body" v-html="text"/>
    <div class="modalWithAction__image" v-if="imageSlot">
      <slot name="image">

      </slot>
    </div>

    <div class="modalWithAction__btn-group">
      <div>
        <v-btn
          v-if="cancelButton"
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="cancel"
        >
          Отменить
        </v-btn>
      </div>
      <div>
        <v-btn
          v-if="acceptButton"
          class="_w-100"
          color="primary"
          @click="accept"
        >
          {{acceptButton}}
        </v-btn>
      </div>

    </div>
  </v-card>
</v-dialog>
</template>

<script>

/**
 * Компонент: modalWithAction
 * Описание:
 */
export default {
  name: 'modalWithAction',
  components: { },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: false
    },
    acceptButton: {
      type: String,
      default: () => ''
    },
    cancelButton: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    widthModal: {
      type: [Number, String],
      required: false,
      default: () => 500,
    },
    imageSlot: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  emits: ['closeModal', 'accept'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    accept() {
      this.$emit('accept');
    },
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
.modalWithAction{
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
    text-align: center;
  }

  &__btn-group{
    display: flex;
    justify-content: center;
  }

  &__body{
    text-align: center;
  }

}
</style>
